import gql from 'graphql-tag';

export default gql(`query{
    layouts{
      id
      name
    }
   }
`);
